export default function UACustomersController() {
  const vm = this;

  vm.handleAddedCustomer = _handleAddedCustomer;
  vm.handleDeletedCustomer = _handleDeletedCustomer;

  // //////// METHODS //////////

  function _handleAddedCustomer(customer) {
    vm.customers.splice(vm.customers.indexOf(customer), 1);
  }

  function _handleDeletedCustomer(customer) {
    vm.customers.splice(vm.customers.indexOf(customer), 1);
  }
}

UACustomersController.$inject = [];
